import { ADD_APPRECIATION, ADD_APPRECIATION_FAILED, ADD_APPRECIATION_SUCCESS, APPRECIATION, APPRECIATION_FAILED, APPRECIATION_SUCCESS, UPDATE_APPRECIATION, UPDATE_APPRECIATION_FAILED, UPDATE_APPRECIATION_SUCCESS, UPDATE_DEPARTMENT_FAILED } from "./actionTypes"

let initialState = {
    appreciation: [],
    addAppreciation: "",
    updateAppreciation: "",
    loading: false,
    success: false,
    error: ''
}

export const appreciationReducer = (state = initialState, action) => {
    switch (action.type) {

        case APPRECIATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case APPRECIATION_SUCCESS: return {
            ...state,
            appreciation: action.payload,
            loading: false,
            success: true
        }
        case APPRECIATION_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_APPRECIATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_APPRECIATION_SUCCESS: return {
            ...state,
            addAppreciation: action.payload,
            appreciation: [...state.appreciation, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_APPRECIATION_FAILED: return {
            ...state,
            addAppreciation: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_APPRECIATION: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_APPRECIATION_SUCCESS: return {
            ...state,
            updateAppreciation: action.payload,
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_APPRECIATION_FAILED: return {
            ...state,
            updateAppreciation: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}